import { format } from 'date-fns';
import type { InsuranceType } from '~/@types/insurance';
import apiAssegurouAuto from '~/services/apiAssegurouAuto';
import { parseDate } from '~/utils/date';
import { Gender, MaritalStatus } from '~/utils/form';
import { getRawCellphone, getRawDocument } from '~/utils/string';
import { getIpv4UseCase } from '../Device/GetIpv4UseCase.index';
import Env from '~/env';

const stepType = {
  ['marisa-cuida']: 'MARISACUIDA',
  ['marisa-auto']: 'AUTO',
  ['bag-protection']: 'PROTECAOBOLSA',
  ['income-protection']: 'PERDARENDA',
  ['odonto-protection']: 'SEGUROODONTO',
};

const productCode = {
  ['marisa-cuida']: Env.SALE_FUNNEL_TAKES_CARE_PRODUCT_CODE,
  ['marisa-auto']: Env.SALE_FUNNEL_AUTO_PRODUCT_CODE,
  ['bag-protection']: Env.SALE_FUNNEL_BAG_PROTECTION_PRODUCT_CODE,
  ['income-protection']: Env.SALE_FUNNEL_INCOME_PROTECTION_PRODUCT_CODE,
  ['odonto-protection']: Env.SALE_FUNNEL_ODONTO_PROTECTION_CODE,
};

const maritalStatus = {
  [MaritalStatus.SINGLE]: 1,
  [MaritalStatus.MARRIED]: 2,
  [MaritalStatus.WIDOWER]: 3,
  [MaritalStatus.DIVORCED]: 4,
};

const gender = {
  [Gender.MALE]: 'M',
  [Gender.FEMALE]: 'F',
  [Gender.NOT_INFORMED]: 'N',
};

interface Config {
  type: InsuranceType;
  stepName: string;
}

export async function sendSalesFunnelStepUseCase(
  config: Config,
  info: SalesFunnel.StepLogBody
) {
  if (config.type === 'unemployment-assistance') {
    return;
  }

  try {
    const ip = await getIpv4UseCase();

    await apiAssegurouAuto.post('funilVendas', {
      ipv4: ip,
      protocolo: info.protocol,
      dataHoraCadastro: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      codProduto: productCode[config.type],
      codEtapa: `${stepType[config.type]}_${config.stepName}`,
      jaPossuiSeguro: info.hasInsurance,
      dataFimVigenciaSeguro: info.finalVigencyDate,
      nomeCompleto: info.fullName,
      numDoc: info.documentNumber
        ? getRawDocument(info.documentNumber)
        : undefined,
      sexo:
        info.gender && info.gender !== 'notInformed'
          ? gender[info.gender as Gender]
          : undefined,
      estadoCivil: info.maritalStatus
        ? maritalStatus[info.maritalStatus as MaritalStatus]
        : undefined,
      dataNascimento: info.birthDate ? parseDate(info.birthDate) : undefined,
      celular: info.cellphone
        ? getRawCellphone(info.cellphone ?? '')
        : undefined,
      email: info.email,
      codProposta: info.proposalCode,
    });
  } catch (err) {
    console.log(err);
  }
}
